function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import PropTypes from "prop-types";
import React from "react";
import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { TypingUser } from "../TypingUser";
import { AutoDraft, ChatEventType } from "../enums";
import { useDebounceTyping } from "./useDebounceTyping";
import { useLazyServiceFactoryRef } from "./useLazyServiceFactoryRef";
import { useThrottledSendTyping } from "./useThrottledSendTyping";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
// Experimental
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ChatContext = /*#__PURE__*/ createContext(undefined);
ChatContext.displayName = "ChatContext";
export const useChat = () => {
    const context = useContext(ChatContext);
    if (!context) {
        throw new Error("useChat must be within ChatProvider");
    }
    return context;
};
/**
 *
 * @param {IStorage} storage
 * @param {IChatService} service
 * @param setter
 * @param config
 */
const useStorage = (storage, service, setter, { debounceTyping = true, typingDebounceTime = 900 }) => {
    const updateState = useCallback(() => {
        setter(storage.getState());
    }, [setter, storage]);
    const debouncedTyping = useDebounceTyping(typingDebounceTime, updateState, storage);
    // Register event handlers
    useEffect(() => {
        const onMessage = ({ message, conversationId }) => {
            storage.addMessage(message, conversationId, false);
            const _storage$getConversat = storage.getConversation(conversationId), _storage$getConversat2 = _slicedToArray(_storage$getConversat, 1), conversation = _storage$getConversat2[0];
            // Increment unread counter
            const _storage$getState = storage.getState(), activeConversation = _storage$getState.activeConversation;
            if (conversation && (!activeConversation || activeConversation.id !== conversationId)) {
                storage.setUnread(conversationId, conversation.unreadCounter + 1);
            }
            // Reset typing
            if (conversation) {
                conversation.removeTypingUser(message.senderId);
            }
            updateState();
        };
        const onConnectionStateChanged = () => { };
        const onUserConnected = () => { };
        const onUserDisconnected = () => { };
        const onUserPresenceChanged = ({ userId, presence }) => {
            storage.setPresence(userId, presence);
        };
        const onUserTyping = ({ conversationId, userId, content, isTyping }) => {
            const _storage$getConversat3 = storage.getConversation(conversationId), _storage$getConversat4 = _slicedToArray(_storage$getConversat3, 1), conversation = _storage$getConversat4[0];
            if (conversation) {
                conversation.addTypingUser(new TypingUser({
                    userId,
                    content,
                    isTyping
                }));
                if (debounceTyping) {
                    debouncedTyping(conversationId, userId);
                }
                updateState();
            }
        };
        service.on(ChatEventType.Message, onMessage);
        service.on(ChatEventType.ConnectionStateChanged, onConnectionStateChanged);
        service.on(ChatEventType.UserConnected, onUserConnected);
        service.on(ChatEventType.UserDisconnected, onUserDisconnected);
        service.on(ChatEventType.UserPresenceChanged, onUserPresenceChanged);
        service.on(ChatEventType.UserTyping, onUserTyping);
        return () => {
            service.off(ChatEventType.Message, onMessage);
            service.off(ChatEventType.ConnectionStateChanged, onConnectionStateChanged);
            service.off(ChatEventType.UserConnected, onUserConnected);
            service.off(ChatEventType.UserDisconnected, onUserDisconnected);
            service.off(ChatEventType.UserPresenceChanged, onUserPresenceChanged);
            service.off(ChatEventType.UserTyping, onUserTyping);
        };
    }, [storage, service, updateState, debounceTyping, debouncedTyping]);
};
export const useChatSelector = ({ conversations, activeConversation, messages, currentMessages, currentMessage }) => {
    return {
        conversations,
        currentMessages,
        messages,
        activeConversation,
        currentMessage
    };
};
/**
 * Provides methods to operate on chat and properties and collections of chat
 * @param children
 * @param {IChatService} service
 * @param {IStorage} storage
 * @constructor
 */
export const ChatProvider = ({ serviceFactory, storage, config: { typingThrottleTime = 250, debounceTyping = true, typingDebounceTime = 900, autoDraft = AutoDraft.Save | AutoDraft.Restore }, children }) => {
    const _useState = useState(storage.getState()), _useState2 = _slicedToArray(_useState, 2), state = _useState2[0], setState = _useState2[1];
    const updateState = useCallback(() => {
        const newState = storage.getState();
        setState(newState);
    }, [setState, storage]);
    const getState = useCallback(() => {
        const newState = storage.getState();
        return newState;
    }, [setState, storage]);
    const getMessagesByConversationId = useCallback(conversationId => {
        const state = storage.getState();
        if (conversationId in state.messages) {
            return state.messages[conversationId];
        }
        return [];
    }, [setState, storage]);
    const currentMessages = useMemo(() => {
        if (state.activeConversation && state.activeConversation.id in state.messages) {
            return state.messages[state.activeConversation.id];
        }
        return [];
    }, [state]);
    const serviceRef = useLazyServiceFactoryRef(serviceFactory, storage, updateState);
    useStorage(storage, serviceRef.current, setState, {
        debounceTyping,
        typingDebounceTime
    });
    const throttledSendTyping = useThrottledSendTyping(serviceRef.current, typingThrottleTime);
    const setCurrentUser = useCallback(user => {
        storage.setCurrentUser(user);
        updateState();
    }, [storage, updateState]);
    const addUser = useCallback(user => {
        const result = storage.addUser(user);
        updateState();
        return result;
    }, [storage, updateState]);
    const removeUser = useCallback(userId => {
        const result = storage.removeUser(userId);
        updateState();
        return result;
    }, [storage, updateState]);
    /**
     * Get user by id
     * @param userId
     */
    const getUser = useCallback(userId => storage.getUser(userId)[0], [storage]);
    /**
     * Update user by id
     * @param userId
     */
    const updateUser = useCallback((userId, user) => {
        const result = storage.updateUser(userId, user);
        updateState();
        return result;
    }, [storage, updateState]);
    /**
     * Set active conversation
     * @param {String} conversationId Conversation id
     */
    const setActiveConversation = useCallback((conversationId, draftOpt = autoDraft) => {
        var _a;
        const _storage$getState2 = storage.getState(), currentMessage = _storage$getState2.currentMessage;
        // Save draft for the current conversation
        if (draftOpt & AutoDraft.Save) {
            storage.setDraft(currentMessage);
        }
        storage.setActiveConversation(conversationId);
        // Set current message input value to the draft from current conversation
        // And reset draft
        if (conversationId) {
            const _storage$getConversat5 = storage.getConversation(conversationId), _storage$getConversat6 = _slicedToArray(_storage$getConversat5, 1), activeConversation = _storage$getConversat6[0];
            if (activeConversation) {
                // Restore draft from new conversation to message input
                if (draftOpt & AutoDraft.Restore) {
                    storage.setCurrentMessage((_a = activeConversation.draft) !== null && _a !== void 0 ? _a : "");
                    activeConversation.draft = "";
                }
            }
        }
        updateState();
    }, [storage, updateState]);
    const getConversation = useCallback(conversationId => storage.getConversation(conversationId)[0], [storage]);
    const getUnreadMessage = useCallback(conversationId => {
        var _a;
        return (_a = state.unreadMessages) === null || _a === void 0 ? void 0 : _a.conversation.find(conversation => conversation.conversationId.toString() === conversationId.toString());
    }, [state.unreadMessages]);
    const getUnreadMessageInBranch = useCallback(branchId => {
        var _a;
        return (_a = state.unreadMessages) === null || _a === void 0 ? void 0 : _a.conversation.filter(conversation => { var _a; return ((_a = conversation === null || conversation === void 0 ? void 0 : conversation.branch_id) === null || _a === void 0 ? void 0 : _a.toString()) === branchId.toString(); });
    }, [state.unreadMessages]);
    const getUnreadMessageInDivision = useCallback(divisionId => {
        var _a;
        return (_a = state.unreadMessages) === null || _a === void 0 ? void 0 : _a.conversation.filter(conversation => { var _a; return ((_a = conversation === null || conversation === void 0 ? void 0 : conversation.business_department_id) === null || _a === void 0 ? void 0 : _a.toString()) === divisionId.toString(); });
    }, [state.unreadMessages]);
    /**
     * Sends message to active conversation
     */
    const sendMessage = useCallback(({ message, conversationId, 
    // senderId,
    generateId = storage.messageIdGenerator ? true : false, clearMessageInput = true }) => {
        const storedMessage = storage.addMessage(message, conversationId, generateId);
        if (clearMessageInput) {
            storage.setCurrentMessage("");
        }
        updateState();
        serviceRef.current.sendMessage({
            message: storedMessage,
            conversationId
        });
    }, [storage, updateState, serviceRef]);
    /**
     * Adds a message without sending it
     * @param message
     * @param conversationId
     * @param generateId
     */
    const addMessage = useCallback((message, conversationId, generateId) => {
        storage.addMessage(message, conversationId, generateId);
        updateState();
    }, [storage, updateState]);
    /**
     * Adds a previous message without sending it
     * @param message
     * @param conversationId
     * @param generateId
     */
    const addPreviousMessage = useCallback((message, conversationId, generateId) => {
        storage.addPreviousMessage(message, conversationId, generateId);
        updateState();
    }, [storage, updateState]);
    /**
     * Update message
     * @param message
     * @param index
     */
    const updateMessage = useCallback(message => {
        storage.updateMessage(message);
        updateState();
    }, [storage, updateState]);
    /**
     * Remove all message by status
     * @param status
     */
    const removeAllMessageByStatus = useCallback(status => {
        storage.removeAllMessageByStatus(status);
        updateState();
    }, [storage, updateState]);
    /**
     * Set draft of message in current conversation
     * @param {String} draft
     */
    const setDraft = useCallback(draft => {
        storage.setDraft(draft);
        updateState();
    }, [storage, updateState]);
    /**
     * Add conversation to collection
     * @param c
     */
    const addConversation = useCallback(c => {
        storage.addConversation(c);
        updateState();
    }, [storage, updateState]);
    /**
     * Remove conversation from collection
     * @param conversationId
     */
    const removeConversation = useCallback((conversationId, removeMessages = true) => {
        const result = storage.removeConversation(conversationId, removeMessages);
        updateState();
        return result;
    }, [storage, updateState]);
    /**
     * Remove all conversation
     */
    const removeAllConversation = useCallback(() => {
        const result = storage.removeAllConversation();
        updateState();
        return result;
    }, [storage, updateState]);
    const resetState = useCallback(() => {
        storage.resetState();
        updateState();
    }, [storage, updateState]);
    /**
     * Sends typing to active conversation
     * @param {Object} options Options object
     */
    const sendTyping = useCallback(({ content = "", isTyping = true, throttle = true }) => {
        const _storage$getState3 = storage.getState(), activeConversation = _storage$getState3.activeConversation, currentUser = _storage$getState3.currentUser;
        if (activeConversation && currentUser) {
            const params = {
                content,
                isTyping,
                userId: currentUser.id,
                conversationId: activeConversation.id
            };
            if (throttle) {
                throttledSendTyping(params);
            }
            else {
                serviceRef.current.sendTyping(params);
            }
        }
    }, [storage, throttledSendTyping, serviceRef]);
    /**
     * Set current  message input value
     * @param message
     */
    const setCurrentMessage = useCallback(message => {
        storage.setCurrentMessage(message);
        updateState();
    }, [storage, updateState]);
    /**
     * Remove all the messages from the conversation
     * @param conversationId
     */
    const removeMessagesFromConversation = useCallback(conversationId => {
        storage.removeMessagesFromConversation(conversationId);
        updateState();
    }, [storage, updateState]);
    const removeMessageByMessagedId = useCallback((messagedId, conversationId) => {
        const removed = storage.removeMessageByMessagedId(messagedId, conversationId);
        if (removed)
            updateState();
        return removed;
    }, [storage, updateState]);
    /**
     * Update description for the conversation
     * @param conversationId
     * @param description
     */
    const setConversationDescription = useCallback((conversationId, description) => {
        if (description) {
            storage.setConversationDescription(conversationId, description);
            updateState();
        }
    }, [storage, updateState]);
    /**
     * Update description for the conversation
     * @param conversation
     */
    const updateConversation = useCallback(conversation => {
        if (conversation) {
            storage.updateConversation(conversation);
            updateState();
        }
    }, [storage, updateState]);
    const getActiveConversation = useCallback(() => {
        return storage.getState().activeConversation;
    }, [setState, storage]);
    return /*#__PURE__*/ React.createElement(ChatContext.Provider, {
        value: _objectSpread(_objectSpread({}, state), {}, {
            currentMessages,
            setCurrentUser,
            addUser,
            removeUser,
            getUser,
            updateUser,
            setActiveConversation,
            sendMessage,
            addMessage,
            updateMessage,
            setDraft,
            sendTyping,
            addConversation,
            removeConversation,
            removeAllConversation,
            getConversation,
            setCurrentMessage,
            resetState,
            updateState,
            getState,
            service: serviceRef.current,
            removeMessagesFromConversation,
            setConversationDescription,
            getMessagesByConversationId,
            removeAllMessageByStatus,
            removeMessageByMessagedId,
            addPreviousMessage,
            updateConversation,
            getActiveConversation
        })
    }, children);
};
ChatProvider.defaultProps = {
    config: {
        typingThrottleTime: 250,
        debounceTyping: true,
        typingDebounceTime: 900
    }
};
ChatProvider.propTypes = {
    children: PropTypes.node,
    service: PropTypes.object,
    storage: PropTypes.object,
    config: PropTypes.object
};
